const EMPTY_RESULT = {
  benefitEvents: {
    items: [],
    size: 0,
    total: 0
  }
}

const normalizeString = (value) => String(value).toLowerCase().trim()

export const filterItems = (data, prop, search, matchType = 'exact') => {
  if (!search || !data?.benefitEvents?.items) {
    return data || EMPTY_RESULT
  }

  const normalizedSearch = normalizeString(search)

  const filteredItems = data.benefitEvents.items.filter((item) => {
    const normalizedValue = normalizeString(item?.[prop] || '')

    return matchType === 'exact' ? normalizedValue === normalizedSearch : normalizedValue.includes(normalizedSearch)
  })

  return {
    benefitEvents: {
      items: filteredItems,
      size: filteredItems.length,
      total: filteredItems.length
    }
  }
}

export const applyFilters = (data, filters) => {
  return filters.reduce((acc, { key, value, type }) => {
    return value ? filterItems(acc, key, value, type) : acc
  }, data)
}
